import { ToastTypeEnum } from "context/toastContext";

interface DownloadFileOptions {
  url: string;
  filename?: string;
  addToast: (arg: { text: string; type: ToastTypeEnum }) => void;
}

const downloadFile = async ({ url, filename, addToast }: DownloadFileOptions): Promise<void> => {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      if (filename) a.download = filename;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch(() => {
      addToast({ text: "Ошибка при скачивании файла", type: ToastTypeEnum.ERROR });
    });
};

export default downloadFile;
